import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef } from 'react';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import { useStyles } from 'components/desktop/_general/Input/InputExtensions/InputTranslateButton/InputTranslateButton.tss';
import SuggestionList from 'components/desktop/_general/TranslatableTextArea/SuggestionList';
import 'components/desktop/_general/TranslatableTextArea/TranslatableTextArea.scss';
import ENTITLEMENTS from 'enums/entitlements';

interface IProps {
	name: string;
	value: string;
	rows: number;
	handleValueChange: (input: string) => void;
	translatable: boolean;
	onBlur?: () => void;
	onTranslateClick: (name: string) => void;
	suggestions?: string[];
	getSuggestions?: (input: string) => void;
	disabled?: boolean;
	errorKey?: string;
}

const TranslatableTextArea = (props: IProps) => {
	const { classes } = useStyles();
	const textArea = useRef<HTMLTextAreaElement>(null);

	const handleValueChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
		props.handleValueChange(e.currentTarget.value);
	};

	const renderGlobe = (): JSX.Element => {
		return (
			<RenderIf entitlements={[ENTITLEMENTS.TRANSLATION_SERVICE]}>
				<span
					className={['input-group-text', classes.button].join(' ')}
					id="basic-addon1"
					onClick={() => props.onTranslateClick(props.name)}
				>
					<FontAwesomeIcon icon={faGlobe} className={classes.icon} />
				</span>
			</RenderIf>
		);
	};

	const renderContent = () => {
		return (
			<div style={{ position: 'relative' }}>
				<div className="input-group">
					<textarea
						ref={textArea}
						className="form-control"
						value={props.value}
						name={props.name}
						rows={props.rows}
						onChange={handleValueChange}
						onBlur={props.onBlur}
						disabled={props.disabled ?? false}
						error-key={props.errorKey}
					/>
					{props.translatable ? <>{renderGlobe()}</> : <></>}
				</div>
				{props.getSuggestions && (
					<SuggestionList
						textArea={textArea}
						suggestions={props.suggestions ?? []}
						getSuggestions={props.getSuggestions}
						handleValueChange={props.handleValueChange}
					/>
				)}
			</div>
		);
	};

	return <>{renderContent()}</>;
};

export default TranslatableTextArea;
